import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

import LoadingOverlay from "./LoadingOverlay";
export default class Deals extends Component {
  constructor(props) {
    super(props);
    const roleData = sessionStorage.getItem("roleData")
      ? JSON.parse(sessionStorage.getItem("roleData"))
      : {};
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.deals_Id,
          sortable: true,
          cell: (row) => <span>{row.deals_Id}</span>,
        },
        {
          name: "Product",
          selector: (row, i) => row.product,
          sortable: true,
          cell: (row) => <span>{row.product}</span>,
        },
        {
          name: "Expected Business Value",
          selector: (row, i) => row.expectedBusinessValue,
          sortable: true,
          cell: (row) => <span>{row.expectedBusinessValue}</span>,
        },
        {
          name: "Expected Business Date",
          selector: (row, i) => row.expectedBusinessDate,
          sortable: true,
          cell: (row) => <span>{row.expectedBusinessDate}</span>,
        },
        {
          name: "Remarks",
          selector: (row, i) => row.remarks,
          sortable: true,
          cell: (row) => <span>{row.remarks}</span>,
        },
        {
          name: "Quote Value",
          selector: (row, i) => row.quoteValue,
          sortable: true,
          cell: (row) => <span>{row.quoteValue}</span>,
        },
        {
          name: "Deal Id",
          selector: (row, i) => row.dealId,
          sortable: true,
          cell: (row) => <span>{row.dealId}</span>,
        },
        {
          name: "Company Id",
          selector: (row, i) => row.companyId,
          sortable: true,
          cell: (row) => <span>{row.companyId}</span>,
        },
        {
          name: "Deal Has Contacts",
          selector: (row, i) => row.dealHasContacts,
          sortable: true,
          cell: (row) => <span>{row.dealHasContacts}</span>,
        },
        {
          name: "Stage Name",
          selector: (row, i) => row.stageName,
          sortable: true,
          cell: (row) => <span>{row.stageName}</span>,
        },
        {
          name: "Deal Owner",
          selector: (row, i) => row.dealOwner,
          sortable: true,
          cell: (row) => <span>{row.dealOwner}</span>,
        },
        {
          name: "Deal Owner Name",
          selector: (row, i) => row.dealOwnerName,
          sortable: true,
          cell: (row) => <span>{row.dealOwnerName}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.DealseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              {roleData.deals_delete && (
                <Button
                  variant="danger"
                  onClick={() => this.handleDelete(row)}
                  className="bi bi-trash danger"
                ></Button>
              )}
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
      deals_Id: "",
      product: "",
      expectedBusinessValue: "",
      expectedBusinessDate: "",
      remarks: "",
      quoteValue: "",
      dealId: "",
      companyId: "",
      dealHasContacts: "",
      company: [],
      stageName: "",
      dealOwner: "",
      leadstages: [],
      employees: [],
      dealOwnerName: "",
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "product",
        inputType: "Text",
        displayName: "Product",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "expectedBusinessValue",
        inputType: "Text",
        displayName: "Expected Business Value",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "expectedBusinessDate",
        inputType: "Date",
        displayName: "Expected Business Date",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "remarks",
        inputType: "Text",
        displayName: "Remarks",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "quoteValue",
        inputType: "Text",
        displayName: "Quote Value",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "dealId",
        inputType: "Text",
        displayName: "Deal Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "companyId",
        inputType: "Text",
        displayName: "Company Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "dealHasContacts",
        inputType: "Text",
        displayName: "Deal Has Contacts",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      product: "",
      expectedBusinessValue: "",
      expectedBusinessDate: "",
      remarks: "",
      quoteValue: "",
      dealId: "",
      companyId: "",
      dealHasContacts: "",
      dealOwner: "",
      stageName: "",
      dealOwnerName: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      product: "",
      expectedBusinessValue: "",
      expectedBusinessDate: "",
      remarks: "",
      quoteValue: "",
      dealId: "",
      companyId: "",
      dealHasContacts: "",
      dealOwner: "",
      stageName: "",
      dealOwnerName: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  DealseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      deals_Id: row.deals_Id,
      product: row.product,
      expectedBusinessValue: row.expectedBusinessValue,
      expectedBusinessDate: row.expectedBusinessDate,
      remarks: row.remarks,
      quoteValue: row.quoteValue,
      dealId: row.dealId,
      companyId: row.companyId,
      dealHasContacts: row.dealHasContacts,
      dealOwner: row.dealOwner,
      stageName: row.stageName,
      dealOwnerName: row.dealOwnerName,
      errors: {},
      touched: {},
    });
  };

  DealsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deals/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  companyfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Company/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ company: data.list });
        }
      });
  };
  LeadstagesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pipelineId", 3);
    fetch(configData.api_url + "C_Leadstages/ListleadStagesBypipelineId", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leadstages: data.list });
        }
      });
  };
  employeesfetchHandler = () => {
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  //id generate
  generateOperationId = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    // Build prefix
    const prefix = `SALES${year}${month}`;
    // Get saved counters from localStorage
    const savedCounters = JSON.parse(
      localStorage.getItem("operationCounters") || "{}"
    );
    // Get current counter for this month
    const currentCount = savedCounters[prefix] || 0;
    const newCount = currentCount + 1;
    // Save back updated count
    savedCounters[prefix] = newCount;
    localStorage.setItem("operationCounters", JSON.stringify(savedCounters));
    // Build final ID
    const countStr = String(newCount).padStart(2, "0");
    return `${prefix}${countStr}`;
  };
  DealssubmitHandler = (e) => {
    e.preventDefault();
    const operationId = this.generateOperationId();
    const uName = sessionStorage.getItem("userName");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("product", this.state.product);
    formData.append("expectedBusinessValue", this.state.expectedBusinessValue);
    formData.append("expectedBusinessDate", this.state.expectedBusinessDate);
    formData.append("remarks", this.state.remarks);
    formData.append("quoteValue", this.state.quoteValue);
    formData.append("dealId", operationId);
    formData.append("companyId", this.state.companyId);
    formData.append("dealHasContacts", this.state.dealHasContacts);
    formData.append("dealOwner", this.state.dealOwner);
    formData.append("stageName", this.state.stageName);
    formData.append("dealOwnerName", this.state.dealOwnerName);
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Deals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DealsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            product: "",
            expectedBusinessValue: "",
            expectedBusinessDate: "",
            remarks: "",
            quoteValue: "",
            dealId: "",
            companyId: "",
            dealHasContacts: "",
            dealOwner: "",
            stageName: "",
          });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  };

  DealsupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    const uName = sessionStorage.getItem("userName");
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deals_Id", this.state.deals_Id);
    formData.append("product", this.state.product);
    formData.append("expectedBusinessValue", this.state.expectedBusinessValue);
    formData.append("expectedBusinessDate", this.state.expectedBusinessDate);
    formData.append("remarks", this.state.remarks);
    formData.append("quoteValue", this.state.quoteValue);
    formData.append("dealId", this.state.dealId);
    formData.append("companyId", this.state.companyId);
    formData.append("dealHasContacts", this.state.dealHasContacts);
    formData.append("dealOwner", this.state.dealOwner);
    formData.append("stageName", this.state.stageName);
    formData.append("dealOwnerName", this.state.dealOwnerName);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Deals/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DealsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  };

  componentDidMount() {
    this.DealsfetchHandler();
    this.companyfetchHandler();
    this.LeadstagesfetchHandler();
    this.employeesfetchHandler();
  }

  handleproductChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ product: fieldValue });
  };
  handleexpectedBusinessValueChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ expectedBusinessValue: fieldValue });
  };
  handleexpectedBusinessDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ expectedBusinessDate: fieldValue });
  };
  handleremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handlequoteValueChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ quoteValue: fieldValue });
  };
  handledealIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dealId: fieldValue });
  };
  handlecompanyIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ companyId: fieldValue });
  };
  handledealHasContactsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dealHasContacts: fieldValue });
  };
  handlestageNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ stageName: fieldValue });
  };
  handledealOwnerChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dealOwner: fieldValue });
  };
  handledealOwnerNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dealOwnerName: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this deals?`)) {
      return;
    }

    var formData = new FormData();
    formData.append("deals_Id", row.deals_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Deals/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DealsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Deals
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Deals</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Product
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleproductChange}
                                        className="form-control"
                                        name="product"
                                        value={this.state.product}
                                        required="required"
                                        placeholder="Enter product"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.product}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Expected Business Value
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleexpectedBusinessValueChange
                                        }
                                        className="form-control"
                                        name="expectedBusinessValue"
                                        value={this.state.expectedBusinessValue}
                                        required="required"
                                        placeholder="Enter expectedBusinessValue"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.expectedBusinessValue
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Expected Business Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleexpectedBusinessDateChange
                                        }
                                        className="form-control"
                                        name="expectedBusinessDate"
                                        value={this.state.expectedBusinessDate}
                                        required="required"
                                        placeholder="Enter expectedBusinessDate"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.expectedBusinessDate
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Remarks
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleremarksChange}
                                        className="form-control"
                                        name="remarks"
                                        value={this.state.remarks}
                                        required="required"
                                        placeholder="Enter remarks"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.remarks}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Quote Value
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlequoteValueChange}
                                        className="form-control"
                                        name="quoteValue"
                                        value={this.state.quoteValue}
                                        required="required"
                                        placeholder="Enter quoteValue"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.quoteValue}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deal Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledealIdChange}
                                        className="form-control"
                                        name="dealId"
                                        value={this.state.dealId}
                                        required="required"
                                        placeholder="Enter dealId"
                                        disabled
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dealId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="companyId"
                                        value={this.state.companyId}
                                        onChange={this.handlecompanyIdChange}
                                        required="required"
                                        placeholder="Enter company Id"
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Insurer{" "}
                                        </option>
                                        {this.state.company.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.companyName}
                                            >
                                              {" "}
                                              {api.companyName}{" "}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deal Has Contacts
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handledealHasContactsChange
                                        }
                                        className="form-control"
                                        name="dealHasContacts"
                                        value={this.state.dealHasContacts}
                                        required="required"
                                        placeholder="Enter dealHasContacts"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dealHasContacts}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Stage Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="stageName"
                                        value={this.state.stageName}
                                        onChange={this.handlestageNameChange}
                                        required="required"
                                        placeholder="Select"
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Stage
                                        </option>
                                        {this.state.leadstages.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.stageName}
                                            >
                                              {" "}
                                              {api.stageName}{" "}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.stageName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deal Owner
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="dealOwner"
                                        value={this.state.dealOwner}
                                        onChange={this.handledealOwnerChange}
                                        required="required"
                                        placeholder="Enter Deal Owner"
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Deal Owner
                                        </option>
                                        {this.state.employees.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.employees_Id}
                                            >
                                              {api.fName}&nbsp;{api.lName}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dealOwner}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deal OwnerName
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="dealOwnerName"
                                        value={this.state.dealOwnerName}
                                        onChange={
                                          this.handledealOwnerNameChange
                                        }
                                        required="required"
                                        placeholder="Enter Deal OwnerName"
                                      >
                                        <option defaultValue>
                                          {" "}
                                          Select Deal Owner
                                        </option>
                                        {this.state.employees.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={`${api.fName} ${api.lName}`}
                                            >
                                              {api.fName}&nbsp;{api.lName}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dealOwner}{" "}
                                    </div>
                                  </Row>
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.DealssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Deals</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Product
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleproductChange}
                                          className="form-control"
                                          name="product"
                                          value={this.state.product}
                                          required="required"
                                          placeholder="Enter product"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.product}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Expected Business Value
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handleexpectedBusinessValueChange
                                          }
                                          className="form-control"
                                          name="expectedBusinessValue"
                                          value={
                                            this.state.expectedBusinessValue
                                          }
                                          required="required"
                                          placeholder="Enter expectedBusinessValue"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors
                                            .expectedBusinessValue
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Expected Business Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this
                                              .handleexpectedBusinessDateChange
                                          }
                                          className="form-control"
                                          name="expectedBusinessDate"
                                          value={
                                            this.state.expectedBusinessDate
                                          }
                                          required="required"
                                          placeholder="Enter expectedBusinessDate"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.expectedBusinessDate
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleremarksChange}
                                          className="form-control"
                                          name="remarks"
                                          value={this.state.remarks}
                                          required="required"
                                          placeholder="Enter remarks"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.remarks}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Quote Value
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlequoteValueChange}
                                          className="form-control"
                                          name="quoteValue"
                                          value={this.state.quoteValue}
                                          required="required"
                                          placeholder="Enter quoteValue"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.quoteValue}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deal Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledealIdChange}
                                          className="form-control"
                                          name="dealId"
                                          value={this.state.dealId}
                                          required="required"
                                          placeholder="Enter dealId"
                                          disabled
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dealId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Company Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="companyId"
                                          value={this.state.companyId}
                                          onChange={this.handlecompanyIdChange}
                                          required="required"
                                          placeholder="Enter company Id"
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Insurer{" "}
                                          </option>
                                          {this.state.company.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.companyName}
                                              >
                                                {" "}
                                                {api.companyName}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.companyId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deal Has Contacts
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledealHasContactsChange
                                          }
                                          className="form-control"
                                          name="dealHasContacts"
                                          value={this.state.dealHasContacts}
                                          required="required"
                                          placeholder="Enter dealHasContacts"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dealHasContacts}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Stage Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="stageName"
                                          value={this.state.stageName}
                                          onChange={this.handlestageNameChange}
                                          required="required"
                                          placeholder="Select"
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Stage
                                          </option>
                                          {this.state.leadstages.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.stageName}
                                              >
                                                {" "}
                                                {api.stageName}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.stageName}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deal Owner
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="dealOwner"
                                          value={this.state.dealOwner}
                                          onChange={this.handledealOwnerChange}
                                          required="required"
                                          placeholder="Enter Deal Owner"
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Deal Owner
                                          </option>
                                          {this.state.employees.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.employees_Id}
                                              >
                                                {api.fName}&nbsp;{api.lName}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dealOwner}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deal OwnerName
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="dealOwnerName"
                                          value={this.state.dealOwnerName}
                                          onChange={
                                            this.handledealOwnerNameChange
                                          }
                                          required="required"
                                          placeholder="Enter Deal OwnerName"
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Deal Owner
                                          </option>
                                          {this.state.employees.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={`${api.fName} ${api.lName}`}
                                              >
                                                {api.fName}&nbsp;{api.lName}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dealOwner}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.DealsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100,
                        ]}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
